// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n625yYnBigo3IA5uIefG {
  border-radius: 20px;
  padding: 16px;
  gap: 8px;
  background: var(--Grey-100, var(--grey-color-10));
  margin: 32px;
  box-shadow: 0px 4px 16px 0px rgba(15, 20, 31, 0.1607843137);
  border: 1px solid var(--Grey-300, #d9d9d9);
}

.y3wzTZwgBskXU2sfZxhA {
  display: flex;
}

.qS6KYXtYYn1iKxX4D9fU {
  width: 75%;
  display: flex;
}

.S1BegVx60XSULswYaNgD {
  display: inline-block;
}

.O2ck2SSPJE_GBeBU1lBf {
  font-weight: bold;
  display: flex;
  padding-left: 5px;
  float: right;
}

.H9RnGuhFL5uo8biKCsAT {
  cursor: pointer;
  text-align: right;
  width: 25%;
}

.Qwq7P8ghLnPNrOFVajus {
  display: inline-block;
}

.DyxSH2ftOXZsggliqTuH {
  display: inline-block;
  padding-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/CohortConfidentialReportBar/CohortConfidentialReportBar.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,iDAAA;EACA,YAAA;EACA,2DAAA;EACA,0CAAA;AACF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,UAAA;EACA,aAAA;AAEF;;AAAA;EACE,qBAAA;AAGF;;AADA;EACE,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;AAIF;;AADA;EACE,eAAA;EACA,iBAAA;EACA,UAAA;AAIF;;AAFA;EACE,qBAAA;AAKF;;AAHA;EACE,qBAAA;EACA,kBAAA;AAMF","sourcesContent":[".barWrapper {\n  border-radius: 20px;\n  padding: 16px;\n  gap: 8px;\n  background: var(--Grey-100, var(--grey-color-10));\n  margin: 32px;\n  box-shadow: 0px 4px 16px 0px #0f141f29;\n  border: 1px solid var(--Grey-300, #d9d9d9);\n}\n.barInner {\n  display: flex;\n}\n\n.barLabelText {\n  width: 75%;\n  display: flex;\n}\n.barInnterText {\n  display: inline-block;\n}\n.barBoldText {\n  font-weight: bold;\n  display: flex;\n  padding-left: 5px;\n  float: right;\n}\n\n.barSwitchView {\n  cursor: pointer;\n  text-align: right;\n  width: 25%;\n}\n.barIcon {\n  display: inline-block;\n}\n.barInfoIcon {\n  display: inline-block;\n  padding-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"barWrapper": `n625yYnBigo3IA5uIefG`,
	"barInner": `y3wzTZwgBskXU2sfZxhA`,
	"barLabelText": `qS6KYXtYYn1iKxX4D9fU`,
	"barInnterText": `S1BegVx60XSULswYaNgD`,
	"barBoldText": `O2ck2SSPJE_GBeBU1lBf`,
	"barSwitchView": `H9RnGuhFL5uo8biKCsAT`,
	"barIcon": `Qwq7P8ghLnPNrOFVajus`,
	"barInfoIcon": `DyxSH2ftOXZsggliqTuH`
};
export default ___CSS_LOADER_EXPORT___;
